'use server';

import { revalidateTag as nextRevalidateTag } from 'next/cache';
import { redirect as nextRedirect } from 'next/navigation';

/**
 * @description Action: wrapper for Next.js revalidateTag function. It revalidates the tag and optionally redirects to path.
 * Can be called inside a client component.
 * @param tag - The tag to revalidate.
 * @param path - Optional path for redirect after revalidation.
 */
export const revalidateTagAction = async (tag: string, path?: string) => {
  nextRevalidateTag(tag, 'max');
  if (path) nextRedirect(path);
};

